/**
 * Lightweight GA4 event helper.
 * Falls back silently when gtag is not loaded (e.g. ad-blockers).
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}
